import { AxiosResponse } from "axios"
import { axiosCoreInstance } from "../../AxiosCoreInterceptor"
import { ProjectedHeadcount } from "../../../Model/Dto/EmploymentEquity/WorkforceProfileGoalsAndTargets/ProjectedHeadcount/ProjectedHeadcount";


const route: string = "EmploymentEquity/ProjectedHeadcount";
export const ProjectedHeadcountService = {

    GetProjectedHeadcount: (id: number): Promise<AxiosResponse<ProjectedHeadcount.Dto>> => axiosCoreInstance.get(`${route}/${id}`),
    CreateProjectedHeadcount: (projectedHeadcount: ProjectedHeadcount.Dto): Promise<AxiosResponse<ProjectedHeadcount.Dto>> => axiosCoreInstance.post(route, projectedHeadcount),
    UpdateProjectedHeadcount: (projectedHeadcount: ProjectedHeadcount.Dto): Promise<AxiosResponse<ProjectedHeadcount.Dto>> => axiosCoreInstance.put(route, projectedHeadcount),
}